// src/components/CookieConsent.jsx
import React, { useState, useEffect } from "react";
import styles from "./CookieConsent.module.css";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("loggable_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const handleConsent = (value) => {
    localStorage.setItem("loggable_cookie_consent", value);
    setVisible(false);

    // Optionally enable/disable analytics here
    if (value === "accepted") {
      // Example: initialize GA
      if (window.gtag) {
        window.gtag("consent", "update", {
          analytics_storage: "granted",
        });
      }
    } else {
      if (window.gtag) {
        window.gtag("consent", "update", {
          analytics_storage: "denied",
        });
      }
    }
  };

  if (!visible) return null;

  return (
    <div className={styles.container}>
      <p className={styles.text}>
        We use cookies to improve your experience. Analytics cookies help us see
        how our site is used. You can accept or decline.
      </p>
      <div className={styles.buttonGroup}>
        <button
          onClick={() => handleConsent("accepted")}
          className={styles.acceptButton}
        >
          Accept
        </button>
        <button
          onClick={() => handleConsent("declined")}
          className={styles.declineButton}
        >
          Decline
        </button>
      </div>
    </div>
  );
}